module.exports = __webpack_public_path__ + "img/04.迎客柏（杨树田-摄）.e442ca9f.jpg";